import { EbUser } from "./user";
import { EbEtablissement } from "./etablissement";
import { EbCompagnie } from "./compagnie";
import { EbDemande } from "./demande";

export class EbInvoice {

  ebInvoiceNum: number;
  ref: string;
  statut: number;
  xEcTypeDemande: number;
  xEcModeTransport: number;
  xEcTypeTransport: number;
  xEcIncoterm: number;
  refDemande: string;
  insurance: boolean;
  insuranceValue: number;
  libelleOriginCountry: string;
  libelleOriginCity: string;
  libelleDestCountry: string;
  libelleDestCity: string;
  totalNbrParcel: number;
  totalVolume: number;
  totalWeight: number;
  totalTaxableWeight: number;
  preCarrierCost: number;
  finalCarrierCost: number;
  datePickup: Date;
  transitTime: number;
  dateDelivery: Date;
  xEbDemandeNum: number;
  dateRequest : Date;
  listLabelStr: string;
  listCategorieStr: string;
  carrier: EbUser;
  xEbEtablissementCarrier: EbEtablissement;
  nomEtablissementCarrier: string;
  xEbCompagnieCarrier: EbCompagnie;
  nomCompanyCarrier: string;
  chargeur: EbUser;
  xEbEtablissementChargeur: EbEtablissement;
  nomEtablissementChargeur: string;
  xEbCompagnieChargeur: EbCompagnie;
  nomCompanyChargeur: string;
  dateAjout: Date;
  dateModification: Date;
  memoCarrier:String;
  memoChageur:string;
  flag:number;
  flagCarrier:number;
  applyChargeurIvoicePrice: number;
  applyCarrierIvoicePrice:number;
  applyChargeurIvoiceNumber: number;
  applyCarrierIvoiceNumber:number;
  uploadFileNbr:number;
  invoiceMonth:number;
  invoiceYear:number;
  invoiceMonthCarrier:number;
  invoiceYearCarrier:number;
  numberArraw: number;
  priceArraw: number;
  dateArraw: number;
  statutChargeur: number;
  statutCarrier: number;

  constructor() {
    this.ebInvoiceNum = null;
    this.ref = null;
    this.statut = null;
    this.xEcTypeDemande = null;
    this.xEcModeTransport = null;
    this.xEcTypeTransport = null;
    this.xEcIncoterm = null;
    this.refDemande = null;
    this.insurance = null;
    this.insuranceValue = null;
    this.libelleOriginCountry = null;
    this.libelleOriginCity = null;
    this.libelleDestCountry = null;
    this.libelleDestCity = null;
    this.totalNbrParcel = null;
    this.totalVolume = null;
    this.totalWeight = null;
    this.totalTaxableWeight = null;
    this.preCarrierCost = null;
    this.finalCarrierCost = null;
    this.datePickup = null;
    this.transitTime = null;
    this.dateDelivery = null;
    this.xEbDemandeNum = null;
    this.dateRequest = null;
    this.listLabelStr = null;
    this.listCategorieStr = null;
    this.carrier = null;
    this.xEbEtablissementCarrier = null;
    this.nomEtablissementCarrier = null;
    this.xEbCompagnieCarrier = null;
    this.nomCompanyCarrier = null;
    this.chargeur = null;
    this.xEbEtablissementChargeur = null;
    this.nomEtablissementChargeur = null;
    this.xEbCompagnieChargeur = null;
    this.nomCompanyChargeur = null;
    this.dateAjout = null;
    this.dateModification = null;
    this.memoCarrier = null;
    this.memoChageur = null;
    this.flag = null;
    this.flagCarrier = null;
    this.uploadFileNbr = null;
    this.applyChargeurIvoicePrice = null;
    this.applyCarrierIvoicePrice = null;
    this.applyChargeurIvoiceNumber = null;
    this.applyCarrierIvoiceNumber = null;
    this.invoiceMonth = null;
    this.invoiceYear = null;
    this.invoiceMonthCarrier = null;
    this.invoiceYearCarrier = null;
    this.numberArraw = null;
    this.priceArraw = null;
    this.dateArraw = null;
    this.statutChargeur = null;
    this.statutCarrier = null

  }

}



// WEBPACK FOOTER //
// ./src/app/classes/invoice.ts